import { Form, Formik } from 'formik'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import styled from 'styled-components'
import Button from '../../../components/buttons/buttons.component'
import { PasswordInput } from '../../../components/form-components/inputs.component'
import Yup from './../../../helpers/custom-yup'

const schema = Yup.object().shape({
	password: Yup.string()
		.password()
		.required('Informe a senha'),
	passwordConfirmation: Yup.string()
		.equalTo(Yup.ref('password'), 'As senhas digitadas não conferem')
		.required('Informe a confirmação da senha')
})

const StyledForm = styled.div`
	width: 300px;
	@media (max-width: 600px) {
		width: 100%;
	}
`

const StyledInputContainer = styled.div`
	margin-top: 4.5rem;
`

const StyledButtonContainer = styled.div`
	margin-top: 5rem;
	display: flex;
	justify-content: flex-end;
`

export default class PasswordForm extends Component {
	constructor(props) {
		super(props)
		this.passwordRef = React.createRef()
		this.passwordConfirmationRef = React.createRef()
	}

	onEnter = () => {
		setTimeout(() => {
			this.passwordRef.current.focus()
		}, 0)
	}

	render() {
		const { onSubmit, onClick, onBack, validateForm } = this.props
		return (
			<Formik
				initialValues={{
					password: '',
					passwordConfirmation: ''
				}}
				onSubmit={onSubmit}
				validationSchema={schema}
				validate={values => validateForm(schema, values)}
				render={props => (
					<Form noValidate>
						<p className="static-information">
							A sua senha deve ter no mínimo 12 caracteres e conter pelo
							menos uma letra maiúscula, uma letra minúscula, 1 número e
							1 caractere especial
						</p>
						<br />
						<br />
						<StyledForm>
							<PasswordInput
								elementRef={this.passwordRef}
								id="password"
								label="Senha *"
								maxLength={256}
								{...props}
							/>
							<StyledInputContainer>
								<PasswordInput
									elementRef={this.passwordConfirmationRef}
									id="passwordConfirmation"
									label="Redigite a senha *"
									maxLength={256}
									{...props}
								/>
							</StyledInputContainer>
						</StyledForm>
						<StyledButtonContainer>
							<Button
								link
								type="button"
								onClick={() => {
									onBack && onBack()
								}}>
								Anterior
							</Button>
							<Button
								primary
								type="submit"
								onClick={() => {
									onClick && onClick(props.isValid)
									if (!props.isValid) {
										const id = Object.keys(props.errors)[0]
										const ref = this[`${id}Ref`]
										if (!ref || !ref.current) return
										ref.current.focus()
									}
								}}>
								Avançar
							</Button>
						</StyledButtonContainer>
					</Form>
				)}
			/>
		)
	}
}

PasswordForm.propTypes = {
	onSubmit: PropTypes.func.isRequired,
	onClick: PropTypes.func
}
